import React from 'react';

type OverviewSectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const OverviewSection: React.FC<OverviewSectionProps> = ({ title, children, className = '' }) => {
  return (
    <main className={`w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
      <div className="w-full flex flex-col justify-start items-start">
        <div className="w-full flex flex-col justify-start items-start gap-4 lg:gap-6">
          <div className="w-full flex justify-start items-center gap-2 lg:gap-4">
            <div
              className="text-[#113D7B] text-xl font-extrabold break-words"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              {title}
            </div>
          </div>
          {children}
        </div>
      </div>
    </main>
  );
};
